import { render } from "./AssessmentTaxInvoice.vue?vue&type=template&id=9889addc&scoped=true"
import script from "./AssessmentTaxInvoice.vue?vue&type=script&lang=js"
export * from "./AssessmentTaxInvoice.vue?vue&type=script&lang=js"

import "./AssessmentTaxInvoice.vue?vue&type=style&index=0&id=9889addc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9889addc"]])

export default __exports__